import React from 'react';
import { connect } from 'react-redux';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';

import { Table,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	Form,
	Input,
	InputNumber,
	Select } from 'antd';

import { fetchDepartmentDutyList,
	closeDutyCategoryModal,
	fetchDutyCategoryList,
	newDutyCategory,
	addDutyCategory,
	saveDutyCategory,
	deleteDutyCategory,
	fetchDutyLevelList,
	changeDutyName,
	newDutyLevel,
	changeDutyLevel,
	changeDutyLevelChild,
	addDutyLevel,
	updateDutyLevel,
	deleteDutyLevel,
	initDuty,
	closeDutyModal,
	addDuty,
	multiDeleteDuty,
	updateDuty,
	closeDutyLevelModal } from '../../actions/department-structure-actions.js';
import departmentDutyService from "../../services/DepartmentStructure/department-duty-service";

const { TextArea } = Input;

class DepartmentDuty extends React.Component {
	state = {};
	componentWillMount() {
		this.props.fetchDepartmentDutyList();
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
		this._handleDutyLevel(nextProps.departmentStructure.dutyLevelList);
	}
	_handleDutyLevel(dutyLevelList) {
		this.setState({dutyLevelList: dutyLevelList});
	}
	openDutyModal() {
		this.props.initDuty(status => {
			if (status) {
				this.setState({
					newDuty: {
						name: null,
						type_id: "0",
						level_bottom: "0",
						level_top: "0",
						description: null
					}
				});
			}
		});
	}
	deleteDutyCategory(index) {
		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				let category = this.props.departmentStructure.dutyCategoryList[index];
				if (!category.unsave) {
					this.props.deleteDutyCategory({id: category.id}, index, res => {
						// console.log(res)
						if (res) {
							if (res.data.Success) {
								message.success("删除职务分类成功", 4);
							}else{
								message.error("删除职务分类失败, " + res.data.Errors[0], 4);
							}							
						}else{
							message.error("删除职务分类失败", 4);
						}
					});
				}else{
					this.props.deleteDutyCategory(null, index, res => {
						// console.log(res)
						// if (res) {
						message.success("删除职务分类成功", 4);
						// }else{
						// 	message.error("删除职务分类失败", 4);
						// }
					});
				}
			},
			onCancel: () => {}
		});
	}
	saveAndExitDutyCategory(index) {
		this.saveDutyCategory(index);
		this.props.closeDutyCategoryModal();
	}
	newDutyCategory() {
		this.props.newDutyCategory({name: "", unsave: true});
	}
	newDutyLevel() {
		let item = {
			salary_bottom: null,
			salary_top: null,
			ratio_top: null,
			ratio_bottom: null,
			level: null,
			type_levels: [],
			unsave: true
		}
		this.props.departmentStructure.dutyLevelType.forEach(type => {
			let typeItem = {
				type_id: type.id,
				l_value: null
			}
			item.type_levels.push(typeItem);
		});
		this.props.newDutyLevel(item);
	}
	saveDutyCategory(index) {
		let posts = this.props.departmentStructure.dutyCategoryList[index];
		console.log(posts);
		if(0 === posts.name.length){
			message.error("职务分类名称不能为空", 4);
		}else{
			if (!posts.unsave) {
				let puts = {id: posts.id, name: posts.name};
				this.props.saveDutyCategory(puts, index, status => {
					if (status) {
						message.success("保存职务分类成功", 4);
					}
				});
			}else{
				this.props.addDutyCategory({name: posts.name}, index, status => {
					if (status) {
						message.success("新增职务分类成功", 4);
					}
				});
			}
		}
		
	}
	changeDutyName(index, event) {
		this.props.changeDutyName(index, event.target.value);
	}
	changeDutyLevel(index, column, value) {
		this.props.changeDutyLevel(index, column, value);
	}
	changeDutyLevelChild(index, childIndex, value) {
		this.props.changeDutyLevelChild(index, childIndex, value);
	}
	deleteDutyLevel(index) {
		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				let deletes = this.props.departmentStructure.dutyLevelList[index];
				if (!deletes.unsave) {
					this.props.deleteDutyLevel({id: deletes.id}, index, status => {
						if (status) {
							message.success("删除职位等级成功", 4);
						}else{
							message.error("删除职位等级失败", 4);
						}
					});
				}else{
					this.props.deleteDutyLevel(null, index, status => {
						if (status) {
							message.success("删除职位等级成功", 4);
						}else{
							message.error("删除职位等级失败", 4);
						}
					}, false);
				}
			},
			onCancel: () => {}
		});
	}
	addDutyLevel(index) {
		let posts = this.state.dutyLevelList[index];
		// let postsId = this.state.dutyLevelList[index].level;
		// let levelId = [],i=0;
		// console.log(this.state.dutyLevelList);
		// this.props.departmentStructure.dutyLevelList.forEach(levelIds => {
		// 	// console.log(levelIds.level);
		// 	levelId[i]=levelIds.level
		// 	i++;
		// 	// if (postsId === levelId.level) {
		// 	// 	message.error("级别不能重复", 4);
		// 	// 	return false;
		// 	// }
		// })
		// console.log(levelId.indexOf(postsId));
		// console.log(levelId);
		// console.log(postsId);
		// console.log(this.props.departmentStructure.dutyLevelList);
		// if (levelId.indexOf(postsId) !== -1){
		// 	message.error("级别不能重复", 4);
		// 	return false;
		// }
		if (posts.salary_bottom > posts.salary_top) {
			message.error("资薪上下限设置有误", 4);
			return false;
		}
		if (posts.ratio_bottom > posts.ratio_top) {
			message.error("系数上下限设置有误", 4);
			return false;
		}

		if (null === posts.level) {
			message.error("级别不能为空", 4);
			return false;			
		}
		if (null === posts.salary_bottom) {
			message.error("资薪下限不能为空", 4);
			return false;			
		}
		if (null === posts.salary_top) {
			message.error("薪资上限不能为空", 4);
			return false;			
		}
		if (null === posts.ratio_top) {
			message.error("系数上限不能为空", 4);
			return false;			
		}
		if (null === posts.ratio_bottom) {
			message.error("系数下限不能为空", 4);
			return false;			
		}
		if (!posts.unsave) {
			this.props.updateDutyLevel(posts, index, (res) => {
				if (res.Success) {
					message.success("修改职务等级成功", 4);
				}else{
					message.error(res.Errors[0]);
				}
			});
		}else{
			this.props.addDutyLevel(posts, index, status => {
				if (status) {
					message.success("新增职务等级成功", 4);
				}
				// else{
				// 	message.success("新增职务等级失败", 4);
				// }
			});
		}
	}
	saveAndExitDutyLevel(index) {
		this.addDutyLevel(index);
		this.props.closeDutyLevelModal();
	}
	changeNewDutyCategory(type_id) {
		let copyState = this.state.newDuty;
		copyState.type_id = type_id;
		this.props.departmentStructure.dutyOptions.forEach((option, index) => {
			if (option.type_id === type_id) {
				this.setState({currentNewDuty: index});
				return false;
			}
		});
		copyState.level_bottom = "0";
		copyState.level_top = "0";
		this.setState({newDuty: copyState});
	}
	changeNewDutyLevel(action, value) {
		let copyState = this.state.newDuty;
		copyState[action] = value;
		this.setState({newDuty: copyState});
	}
	changeNewDutyName(event) {
		let copyState = this.state.newDuty;
		copyState.name = event.target.value;
		this.setState({newDuty: copyState});
	}
	changeNewDutyDesc(event) {
		let copyState = this.state.newDuty;
		copyState.description = event.target.value;
		this.setState({newDuty: copyState});
	}
	addDuty() {
		if (this.state.newDuty.level_bottom > this.state.newDuty.level_top) {
			message.error("职务等级设置有误", 4);
			return false;			
		}
		if (!this.state.newDuty.name || !this.state.newDuty.name.length) {
			message.error("职务名字不能为空", 4);
			return false;				
		}
		if (this.state.newDuty.type_id === "0") {
			message.error("职务分类不能为空", 4);
			return false;
		}
		if (this.state.newDuty.level_bottom === "0") {
			message.error("职务等级下限不能为空", 4);
			return false;				
		}
		if (this.state.newDuty.level_top === "0") {
			message.error("职务等级上限不能为空", 4);
			return false;				
		}
		if (this.state.newDuty.id) {
			this.props.updateDuty(this.state.newDuty, status => {
				if (status) {
					message.success("编辑职务成功", 4);
					this.props.fetchDepartmentDutyList();		
				}
			})
		}else{
			this.props.addDuty(this.state.newDuty, status => {
				if (status) {
					message.success("新增职务成功", 4);
					this.props.fetchDepartmentDutyList();				
				}
			});
		}
	}
	saveDuty(text, record, index) {
		this.props.initDuty(status => {
			if (status) {
				let saveDuty = this.props.departmentStructure.dutyList[index];
				this.props.departmentStructure.dutyOptions.forEach((option, index) => {
					if (option.type_id === saveDuty.type_id) {
						this.setState({currentNewDuty: index});
						return false;
					}
				});
				this.setState({newDuty: saveDuty});
			}
		});
	}
	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let selectedIDs = [];
			selectedRows.forEach(row => {
				selectedIDs.push(row.id);
			});
			this.setState({selectedIDs: selectedIDs});
		}
	};
	multiDelete() {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error("请选择要删除的职务", 4);
			return false;		
		}

		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				this.props.multiDeleteDuty({ids: this.state.selectedIDs}, status => {
					console.log(status);
					if (status) {
						message.success("删除职务成功", 4);
						this.props.fetchDepartmentDutyList();
					}
					// else{
					// 	message.error("删除职务失败", 4);
					// }
				});
			},
			onCancel: () => {}
		});
	}
	fetchDutyPage(pagination) {
		this.props.fetchDepartmentDutyList(pagination.current);
	}

	saveAllDutyCategory	= () => {
		// console.log(this.props.departmentStructure.dutyCategoryList)
		// this.props.departmentStructure.dutyCategoryList.forEach(item => )
		for (let i = 0, len = this.props.departmentStructure.dutyCategoryList.length; i < len; i ++) {
			if (!this.props.departmentStructure.dutyCategoryList[i].name) {
				message.error("分类名称不能为空", 4);
				return;
			}
		}
		departmentDutyService.saveAllDutyCategory({
			business_types: this.props.departmentStructure.dutyCategoryList
		}, res => {
			if (res.data.Success) {
				message.success("保存职务分类成功", 4)
				this.props.closeDutyCategoryModal();
			}else{
				message.error("保存职务分类失败," + res.data.Message, 4)
			}
		}, err => {
			message.error("保存职务分类失败");
		})
	}

	saveAllDutyLevel = () => {
		console.log(this.props.departmentStructure.dutyLevelList)
		for (let i = 0, len = this.props.departmentStructure.dutyLevelList.length; i < len; i ++) {
			if (!this.props.departmentStructure.dutyLevelList[i].level) {
				message.error("请填写等级", 4);
				return;
			}
			if (!this.props.departmentStructure.dutyLevelList[i].ratio_bottom) {
				message.error("请填写系数下限", 4);
				return;
			}
			if (!this.props.departmentStructure.dutyLevelList[i].ratio_top) {
				message.error("请填写系数上限", 4);
				return;
			}
			if (!this.props.departmentStructure.dutyLevelList[i].salary_bottom) {
				message.error("请填写工资下限", 4);
				return;
			}
			if (!this.props.departmentStructure.dutyLevelList[i].salary_top) {
				message.error("请填写工资上限", 4);
				return;
			}
			for (let j = 0, jlen = this.props.departmentStructure.dutyLevelList[i].type_levels.length; j < jlen; j ++) {
				if (!this.props.departmentStructure.dutyLevelList[i].type_levels[j].l_value) {
					message.error("请填写等级", 4);
					return;
				}				
			}
		}
		departmentDutyService.saveAllDutyLevel({
			business_levels: this.props.departmentStructure.dutyLevelList
		}, res => {
			if (res.data.Success) {
				message.success("保存职务分类成功", 4)
				this.props.closeDutyLevelModal();
			}else{
				message.error("保存职务分类失败," + res.data.Message, 4)
			}
		}, err => {
			message.error("保存职务分类失败");
		})			
	}


	render() {
		const columns = [
			{
				title: '职务名称',
				dataIndex: 'name',
			}, {
				title: '职务分类',
				dataIndex: 'type_name',
			}, {
				title: '等级下限',
				dataIndex: 'level_bottom',
			},{
				title: '等级上限',
				dataIndex: 'level_top',
			}, {
				title: '职务描述',
				dataIndex: 'description',
			}, {
				title: '操作',
				dataIndex: 'action',
				render: (text, record, index) => this.props.access.departmentDuty.u_value && 
					<span>
						<span title="编辑" onClick={this.saveDuty.bind(this, text, record, index)}>
							<Button icon="edit" size="small" className="row-action-btn">编辑</Button>
						</span>
					</span>
				
			}
		];
		return (
			<div className="app-module-item">
				<div className="colAction">
					{this.props.access.departmentDuty.c_value && <Button type="primary" onClick={this.openDutyModal.bind(this)} style={{marginRight: "10px"}}>
						<Icon type="plus-circle-o" />
						<span>新增</span>
					</Button>}
					{this.props.access.departmentDuty.d_value && <Button type="primary" onClick={this.multiDelete.bind(this)} style={{marginRight: "10px"}}>
						<Icon type="delete" />
						<span>批量删除</span>
					</Button>}
					{this.props.access.departmentDuty.c_value && <Button type="primary" onClick={this.props.fetchDutyCategoryList} style={{marginRight: "10px"}}>
						<Icon type="bars" />
						<span>职务分类</span>
					</Button>}
					{this.props.access.departmentDuty.c_value && <Button type="primary" onClick={this.props.fetchDutyLevelList} style={{marginRight: "10px"}}>
						<Icon type="profile" />
						<span>职务等级</span>
					</Button>}
				</div>
				{this.props.departmentStructure.dutyListStatus ?
				<Table rowSelection={this.rowSelection} columns={columns} rowKey={record => record.id}
					dataSource={this.props.departmentStructure.dutyList}
					pagination={{
						total: this.props.departmentStructure.totalDuty,
						pageSize:this.props.departmentStructure.pageSizeDuty,
						current: this.props.departmentStructure.pageDuty, 
						defaultCurrent: 1}}
					onChange={this.fetchDutyPage.bind(this)} />
				: 
				<div style={{textAlign:'center', margin: '100px 0px'}}><Spin size="large" /></div>
				}
				<Modal width="800px"
					visible={this.props.departmentStructure.initDutyStatus}
					title="职务"
					destroyOnClose={true}
					onCancel={this.props.closeDutyModal.bind(this)}
					onOk={this.addDuty.bind(this)}>
					{this.state.newDuty &&
					<div style={{height:"460px",overflow:"auto",textAlign:"center"}}>
						<div style={{marginBottom:"35px"}}>
							<span style={{marginRight:"15px"}}>职务名称 :</span>
							<Input style={{width:"400px"}} value={this.state.newDuty.name}
								onChange={this.changeNewDutyName.bind(this)} />
						</div>
						<div style={{marginBottom:"35px"}}>
							<span style={{marginRight:"15px"}}>职务分类 :</span>
							<Select style={{width:"400px"}} value={this.state.newDuty.type_id}
								onChange={this.changeNewDutyCategory.bind(this)}>
								<Select.Option key="-1" disabled value="0">请选择分类</Select.Option>
								{this.props.departmentStructure.dutyOptions && this.props.departmentStructure.dutyOptions.map((options, index) => {
									return (<Select.Option key={index} value={options.type_id}>{options.name}</Select.Option>)
								})}							
							</Select>
						</div>
						<div style={{marginBottom:"35px"}}>
							<span style={{marginRight:"15px"}}>职务等级 :</span>
							<Select style={{width:"160px"}} value={this.state.newDuty.level_bottom}
								onChange={this.changeNewDutyLevel.bind(this, "level_bottom")}>
								<Select.Option key="-1" disabled value="0">请选择等级上限</Select.Option>
								{this.props.departmentStructure.dutyOptions && this.props.departmentStructure.dutyOptions[this.state.currentNewDuty] &&
									this.props.departmentStructure.dutyOptions[this.state.currentNewDuty].levels.map((level, index) => {
									return (<Select.Option key={level} value={level}>{level}</Select.Option>);
								})}
							</Select>
							<span style={{display:"inline-block",width:"80px"}}> - - </span>
							<Select style={{width:"160px"}} value={this.state.newDuty.level_top}
								onChange={this.changeNewDutyLevel.bind(this, "level_top")}>
								<Select.Option key="-1" disabled value="0">请选择等级下限</Select.Option>
								{this.props.departmentStructure.dutyOptions && this.props.departmentStructure.dutyOptions[this.state.currentNewDuty] &&
									this.props.departmentStructure.dutyOptions[this.state.currentNewDuty].levels.map((level, index) => {
									return (<Select.Option key={level} value={level}>{level}</Select.Option>);
								})}
							</Select>
						</div>
						<div style={{marginBottom:"35px"}}>
							<span style={{marginRight:"15px",height:"94px",display:"inline-block"}}>职务描述 :</span>
							<TextArea style={{width:"400px"}} rows={6} value={this.state.newDuty.description}
								onChange={this.changeNewDutyDesc.bind(this)} />
						</div>
					</div>
					}
				</Modal>				
				<Modal width="800px"
					visible={this.props.departmentStructure.dutyCategoryListStatus}
					title="职务分类"
					destroyOnClose={true}
					onCancel={this.props.closeDutyCategoryModal}
        	footer={[
        		<Button key={1} type="default" onClick={this.props.closeDutyCategoryModal}>关闭</Button>,
        		this.props.access.departmentDuty.u_value && <Button key={2} type="primary" onClick={this.saveAllDutyCategory}>保存</Button>]}>
					<div style={{height:"460px",overflow:"auto"}}>
						<div className="ant-table-body">
							<table style={{width:"100%"}}>
								<thead className="ant-table-thead">
								<tr>
									<th><span>职务分类名称</span></th>
									<th ><span>操作</span></th>
								</tr>
								</thead>
								<tbody className="ant-table-tbody">
									{this.props.departmentStructure.dutyCategoryList && 
										this.props.departmentStructure.dutyCategoryList.map((category, index) => {
										return (
											<tr key={index}>
												<td>
													<span>
														<Input value={category.name} onChange={this.changeDutyName.bind(this, index)} />
													</span>
												</td>
												<td>
													<span>
														{this.props.access.departmentDuty.d_value && <span title="删除" onClick={this.deleteDutyCategory.bind(this, index)}>
															{/*<Icon className="icon-hover-pointer" style={{fontSize:"16px",margin:"0px 4px",color:"red"}} />*/}
															<Button icon="delete" size="small" className="row-action-btn">删除</Button>
														</span>}
{/*														<span title="保存" onClick={this.saveDutyCategory.bind(this, index)}>
															<Button icon="save" size="small" className="row-action-btn">保存</Button>
														</span>
														<span title="保存退出" onClick={this.saveAndExitDutyCategory.bind(this, index)}>
															<Button icon="check" size="small" className="row-action-btn">保存退出</Button>
														</span>*/}
													</span>
												</td>
											</tr>
										)})}								
								</tbody>
							</table>
						</div>
						<div style={{textAlign:"center",marginTop:"15px"}}>
							<Button type="primary" style={{width:"120px"}} onClick={this.newDutyCategory.bind(this)}>
								<Icon type="plus-circle-o" /><span>新增</span>
							</Button>
						</div>
					</div>
				</Modal>
				<Modal width="1000px"
					visible={this.props.departmentStructure.dutyLevelListStatus}
					title="职务等级"
					destroyOnClose={true}
					onCancel={this.props.closeDutyLevelModal}
					footer={[
						<Button key={1} type="default" onClick={this.props.closeDutyLevelModal}>关闭</Button>,
						this.props.access.departmentDuty.u_value && <Button key={2} type="primary" onClick={this.saveAllDutyLevel}>保存</Button>]}>
					<div style={{height:"450px",overflow:"auto"}}>
						<div className="ant-table-body">
							<table style={{minWidth:"100%",overflowX:"auto"}}>
								<thead className="ant-table-thead">
									<tr>
										<th style={{minWidth:"120px"}}><span>级别</span></th>
										{this.props.departmentStructure.dutyLevelType.length > 0 &&
											this.props.departmentStructure.dutyLevelType.map(type => 
												<th style={{minWidth:"120px"}} key={type.name}><span>{type.name}</span></th>
										)}
										<th style={{minWidth:"120px"}}><span>薪资下限(元)</span></th>
										<th style={{minWidth:"120px"}}><span>薪资上限(元)</span></th>
										<th style={{minWidth:"120px"}}><span>系数下限(%)</span></th>
										<th style={{minWidth:"120px"}}><span>系数上限(%)</span></th>
										<th style={{minWidth:"120px"}}><span>操作</span></th>
									</tr>
								</thead>
								<tbody className="ant-table-tbody">
									{this.state.dutyLevelList && this.state.dutyLevelList.map((level, index) => { 
										return(<tr key={index}>
											<td>
												<InputNumber min={1} value={level.level}
													onChange={this.changeDutyLevel.bind(this, index, "level")} />
											</td>
											{level.type_levels.map((category, childIndex) => { 
												return (<td key={childIndex}>
													<InputNumber min={1} value={category.l_value}
														onChange={this.changeDutyLevelChild.bind(this, index, childIndex)} />
												</td>)})}
											<td>
											{/*<Form.Item>
											{this.props.form.getFieldDecorator('salary_bottom', {
									            rules: [{
									              required: true, message: '请输入级别!',
									            }, {
									              validator: level.salary_bottom,
									            }],
				          					})(*/}
												<InputNumber min={0} step={0.1} value={level.salary_bottom} 
													onChange={this.changeDutyLevel.bind(this, index, "salary_bottom")} />
				          					{/*)}</Form.Item>*/}
											</td>

											<td>
												<InputNumber min={0} step={0.1} value={level.salary_top}
													onChange={this.changeDutyLevel.bind(this, index, "salary_top")} />
											</td>	
											<td>
												<InputNumber min={0} max={100.0} step={0.1} value={level.ratio_bottom}
													onChange={this.changeDutyLevel.bind(this, index, "ratio_bottom")} />
											</td>	
											<td>
												<InputNumber min={0} max={100.0} step={0.1} value={level.ratio_top}
													onChange={this.changeDutyLevel.bind(this, index, "ratio_top")} />
											</td>
											<td>
												<span>
													{this.props.access.departmentDuty.d_value && <span title="删除" onClick={this.deleteDutyLevel.bind(this, index)}>
														<Button icon="delete" size="small" className="row-action-btn">删除</Button>
													</span>}
{/*													<span title="保存" onClick={this.addDutyLevel.bind(this, index)}>
														<Button icon="save" size="small" className="row-action-btn">保存</Button>
													</span>
													<span title="保存退出" onClick={this.saveAndExitDutyLevel.bind(this, index)}>
														<Button icon="check" size="small" className="row-action-btn">保存退出</Button>
													</span>*/}
												</span>
											</td>
										</tr>)
									})}
								</tbody>
							</table>
						</div>
						<div style={{textAlign:"center",marginTop:"15px"}}>
							<Button type="primary" style={{width:"120px"}} onClick={this.newDutyLevel.bind(this)}>
								<Icon type="plus-circle-o" /><span>新增</span>
							</Button>
						</div>
					</div>					
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure
	}
};
const mapDispatchToProps = {
	fetchDepartmentDutyList,
	closeDutyCategoryModal,
	fetchDutyCategoryList,
	newDutyCategory,
	addDutyCategory,
	changeDutyName,
	saveDutyCategory,
	deleteDutyCategory,
	fetchDutyLevelList,
	closeDutyLevelModal,
	newDutyLevel,
	changeDutyLevel,
	changeDutyLevelChild,
	addDutyLevel,
	updateDutyLevel,
	deleteDutyLevel,
	initDuty,
	closeDutyModal,
	addDuty,
	multiDeleteDuty,
	updateDuty
};
DepartmentDuty = Form.create()(DepartmentDuty);
DepartmentDuty = LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(DepartmentDuty));

export default DepartmentDuty;



// WEBPACK FOOTER //
// ./src/routes/DepartmentStructure/DepartmentDuty.js